import { IHydraConfig } from '@assess/browser/hydra';

import { environment } from '../../environments/environment';

export const hydraConfig: IHydraConfig = environment.hydra;
